"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGoogleCalendarsForCompany = exports.getGoogleAuthUrl = exports.checkRefreshTokenValidity = void 0;
const graphql_1 = require("../../../../../services/graphql");
const mapped_env_variables_1 = require("../../../../../utilities/environment/mapped-env-variables");
async function checkRefreshTokenValidity(companyId) {
    try {
        const gqlResult = await (0, graphql_1.gqlRequestResult)(mapped_env_variables_1.currentMappedEnvVariables.graphqlMediumContainerEndpoint).execute((0, graphql_1.gql) `
                query ($companyId: Int!) {
                    isGoogleRefreshTokenValid(companyId: $companyId)
                }
            `, {
            companyId,
        });
        if (gqlResult.succeeded === false)
            return gqlResult;
        const isRefreshTokenValid = gqlResult.value.data.isGoogleRefreshTokenValid;
        return {
            succeeded: true,
            value: isRefreshTokenValid,
        };
    }
    catch (error) {
        throw new Error(`checkRefreshTokenValidity error: ${error}`);
    }
}
exports.checkRefreshTokenValidity = checkRefreshTokenValidity;
async function getGoogleAuthUrl(companyId) {
    try {
        const gqlResult = await (0, graphql_1.gqlRequestResult)(mapped_env_variables_1.currentMappedEnvVariables.graphqlMediumContainerEndpoint).execute((0, graphql_1.gql) `
                query ($companyId: Int!) {
                    getGoogleAuthURL(companyId: $companyId)
                }
            `, {
            companyId,
        });
        if (gqlResult.succeeded === false)
            return gqlResult;
        const authorizationUrl = gqlResult.value.data.getGoogleAuthURL;
        return {
            succeeded: true,
            value: authorizationUrl,
        };
    }
    catch (error) {
        throw new Error(`getGoogleAuthUrl error: ${error}`);
    }
}
exports.getGoogleAuthUrl = getGoogleAuthUrl;
async function fetchGoogleCalendarsForCompany(companyId) {
    try {
        const gqlResult = await (0, graphql_1.gqlRequestResult)(mapped_env_variables_1.currentMappedEnvVariables.graphqlMediumContainerEndpoint).execute((0, graphql_1.gql) `
                query ($companyId: Int!) {
                    getCompanies(id: $companyId) {
                        id
                        calendar_connections(filter: {archived_at: {eq: null}}) {
                            id
                            google_calendar_id
                            google_calendar_name
                            is_visible
                        }
                    }
                }
            `, {
            companyId,
        });
        if (gqlResult.succeeded === false)
            return gqlResult;
        const calendars = gqlResult.value.data.getCompanies.calendar_connections;
        return {
            succeeded: true,
            value: calendars,
        };
    }
    catch (error) {
        throw new Error(`fetchGoogleCalendarsForCompany error: ${error}`);
    }
}
exports.fetchGoogleCalendarsForCompany = fetchGoogleCalendarsForCompany;
